module.exports = __webpack_public_path__ + "img/HeroTypesQuiz-Q6.a5d31a1c.png";